import { render, staticRenderFns } from "./myBots.vue?vue&type=template&id=5da76a38&scoped=true&lang=pug"
import script from "./myBots.vue?vue&type=script&lang=js"
export * from "./myBots.vue?vue&type=script&lang=js"
import style0 from "./myBots.vue?vue&type=style&index=0&id=5da76a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da76a38",
  null
  
)

export default component.exports